/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './css/AdminPanel.css';
import { ERROR_TEXT } from '../../Utils/Constants/GlobalConstants';
import { SUCCESSFULLY_UPDATED } from '../../Utils/Constants/AdminConstants';
import Operator from './Operator';

function Operators() {
  const [operators, setOperators] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const getOperators = () => {
    const token = window.localStorage.getItem('accessToken');
    axios
      .get('/api/tv/operators/all', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((result) => {
        if (result && result.data && result.data.length > 0) {
          setOperators(result.data);
          setSelectedId(result.data[0].operatorId);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getOperators();
  }, []);

  const handleOperatorChange = (operator) => {
    const newOperatorState = operators.map((item) => {
      if (item.operatorId === operator.operatorId) {
        return operator;
      }

      return item;
    });

    setOperators(newOperatorState);
  };

  const handleSave = async (operator) => {
    const token = window.localStorage.getItem('accessToken');

    const resoponse = await axios
      .post('/api/tv/operators/save', operator, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch(() => null);

    if (resoponse && resoponse.data === 'Successfully updated') {
      alert(SUCCESSFULLY_UPDATED);
    } else {
      alert(ERROR_TEXT);
    }
  };

  const getOperatorClass = (id) =>
    `ap_small_btn ${
      selectedId === id ? 'btn__blue wm_text_14' : 'light_gray_button bm_text_14'
    }`;

  const renderOperatorsMenu = () =>
    operators.map((operator) => (
      <button
        key={`ap-operator-${operator.operatorId}`}
        type="button"
        className={getOperatorClass(operator.operatorId)}
        onClick={() => setSelectedId(operator.operatorId)}
      >
        {operator.name}
      </button>
    ));

  const selected = operators.find(
    (operator) => operator.operatorId === selectedId,
  );

  return (
    <div>
      {operators.length > 0 && (
        <div className="ap_tabs mb_20">{renderOperatorsMenu()}</div>
      )}
      {selected && (
        <Operator
          operator={selected}
          onChange={handleOperatorChange}
          onSave={handleSave}
        />
      )}
    </div>
  );
}

export default Operators;
